// extracted by mini-css-extract-plugin
export default {"container":"PartnerCompanies_container__t3q6C","content":"PartnerCompanies_content__IGA0p","title":"PartnerCompanies_title__VusDx","cards":"PartnerCompanies_cards__5006j"};